// import { useTranslation } from "react-i18next";
import { useEffect } from 'react';
import { useAppDispatch, useAppSelector } from '../../store/hooks';
import { GetPosCashersByPosId } from '../../store/Sales/Pos/PosCashierSlice';
import { useTranslation } from 'react-i18next';

type Props = {
  posId: string;
};
const useGetCashierListByPosId = ({ posId }: Props) => {
  const dispatch = useAppDispatch();

  const { i18n } = useTranslation();

  useEffect(() => {
    if (!posId) return;
    dispatch(GetPosCashersByPosId(posId));
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [posId]);

  const { PosCashierListByPosId: PosCashierList, loading, error } = useAppSelector(a => a.PosCashier);

  const CashierOptions = PosCashierList?.map(m => ({
    value: m.id,
    label: i18n.language === 'en' ? m.personName : m.personName2
  }));

  return { PosCashierList, CashierOptions, loading, error };
};

export default useGetCashierListByPosId;
